module.exports = __webpack_public_path__ + "static/img/sz01.3815c77f.png";